import throttle from 'lodash.throttle';

function isWidgetVisible(widget, pixelsOffset = 0) {
    return (
        widget.getBoundingClientRect().bottom - pixelsOffset <=
        (window.innerHeight || document.documentElement.clientHeight)
    );
}

function watchVisible(widgetId, widgetElement) {
    const widget = widgetElement || document.getElementById(widgetId);
    const throttleTime = 200;
    const pixelsOffset = 100;

    return new Promise(resolve => {
        let intervalCheck = null;

        if (typeof window === 'undefined') return Promise.resolve();

        const throttleHandlerDebounce = throttle(() => {
            if (isWidgetVisible(widget, pixelsOffset)) {
                // console.log('there it is')
                window.removeEventListener('scroll', throttleHandlerDebounce);
                throttleHandlerDebounce.cancel();
                if (intervalCheck) clearInterval(intervalCheck);
                resolve();
            } else {
                // console.log('not here yet')
            }
        }, throttleTime);

        if (window[`ab_isEventListenerAddedForWidgetVisible_${widget.id}`]) return;

        window.addEventListener('scroll', throttleHandlerDebounce);
        window[`ab_isEventListenerAddedForWidgetVisible_${widget.id}`] = true;

        intervalCheck = setInterval(() => {
            throttleHandlerDebounce();
        }, 200);
    });
}

export default watchVisible;



// WEBPACK FOOTER //
// ./src/utils/old-riot-code/widget-visible.js